<template>
  <lb-dialog
    :value="value"
    @input="$emit('input', $event)"
    heading="All Task Status Report"
    width="600"
    data-testid="task-status-report-dialog"
  >
    <template v-slot:body>
      <div>
        <div>
          The status below is shown for the
          <span class="font-weight-bold noTransform">{{
            userType ? userType[0].toUpperCase() + userType.slice(1) : ''
          }}</span>
          role:
        </div>
        <v-card-text class="pa-4" data-testid="task-status-report-dialog__content">
          <div class="my-1">
            <div class="d-flex align-center">
              <v-icon color="#C69908">mdi-timer-sand-empty</v-icon>
              <span class="ml-2 pending_sub_tab_color"
                >Pending Submission Not Due</span
              >
              <v-spacer></v-spacer>
              <v-chip
                style="width: 40px; text-align: center"
                color="#C69908"
                label
                class="d-inline"
                text-color="white"
                data-testid="task-status-report-dialog__pending-submission-not-due-chip"
              >
                <span>{{ details.pending_not_due || 0 }}</span>
              </v-chip>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="my-1">
            <div class="d-flex align-center" data-testid="task-status-report-dialog__pending-submission-due-section">
              <v-icon color="#C69908">mdi-timer-sand-paused</v-icon>
              <span class="ml-2 pending_sub_tab_color"
                >Pending Submission Due</span
              >
              <v-spacer></v-spacer>
              <v-chip
                style="width: 40px; text-align: center"
                color="#C69908"
                label
                class="d-inline"
                text-color="white"
                data-testid="task-status-report-dialog__pending-submission-due-chip"
              >
                <span>{{ details.pending_due || 0 }}</span>
              </v-chip>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="my-1">
            <div class="d-flex align-center" data-testid="task-status-report-dialog__pending-submission-overdue-section">
              <v-icon color="#C69908">mdi-timer-sand-full</v-icon>
              <span class="ml-2 pending_sub_tab_color"
                >Pending Submission Overdue</span
              >
              <v-spacer></v-spacer>
              <v-chip
                style="width: 40px; text-align: center"
                color="#C69908"
                label
                class="d-inline"
                text-color="white"
                data-testid="task-status-report-dialog__pending-submission-overdue-chip"
              >
                <span>{{ details.pending_over_due || 0 }}</span>
              </v-chip>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="mt-8">
            <v-divider></v-divider>
            <div class="my-1">
              <div class="d-flex align-center" data-testid="task-status-report-dialog__pending-approval-not-due-section">
                <v-icon color="#4285F4">mdi-timer-sand-empty</v-icon>
                <span class="ml-2 pending_app_tab_color"
                  >Pending Approval Not Due</span
                >
                <v-spacer></v-spacer>
                <v-chip
                  style="width: 40px; text-align: center"
                  color="#4285F4"
                  label
                  class="d-inline"
                  text-color="white"
                  data-testid="task-status-report-dialog__pending-approval-not-due-chip"
                >
                  <span>{{ details.pendingapproval_not_due || 0 }}</span>
                </v-chip>
              </div>
            </div>

            <v-divider></v-divider>
            <div class="my-1">
              <div class="d-flex align-center" data-testid="task-status-report-dialog__pending-approval-due-section">
                <v-icon color="#4285F4">mdi-timer-sand-paused</v-icon>
                <span class="ml-2 pending_app_tab_color"
                  >Pending Approval Due</span
                >
                <v-spacer></v-spacer>
                <v-chip
                  style="width: 40px; text-align: center"
                  color="#4285F4"
                  label
                  class="d-inline"
                  text-color="white"
                  data-testid="task-status-report-dialog__pending-approval-due-chip"
                >
                  <span>{{ details.pendingapproval_due || 0 }}</span>
                </v-chip>
              </div>
            </div>
            <v-divider></v-divider>
            <div class="my-1">
              <div class="d-flex align-center" data-testid="task-status-report-dialog__pending-approval-overdue-section">
                <v-icon color="#4285F4">mdi-timer-sand-full</v-icon>
                <span class="ml-2 pending_app_tab_color"
                  >Pending Approval Overdue</span
                >
                <v-spacer></v-spacer>
                <v-chip
                  style="width: 40px; text-align: center"
                  color="#4285F4"
                  label
                  class="d-inline"
                  text-color="white"
                  data-testid="task-status-report-dialog__pending-approval-overdue-chip"
                >
                  <span>{{ details.pendingapproval_over_due || 0 }}</span>
                </v-chip>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="mt-8">
            <v-divider></v-divider>
            <div class="my-1" data-testid="task-status-report-dialog__closed-task-section">
              <div class="d-flex align-center" data-testid="task-status-report-dialog__closed-task-content">
                <v-icon color="green">mdi-check-circle</v-icon>
                <span class="ml-2 closed_tab_color">Closed Task</span>
                <v-spacer></v-spacer>
                <v-chip
                  style="width: 40px; text-align: center"
                  color="#37AE78"
                  label
                  class="d-inline"
                  text-color="white"
                  data-testid="task-status-report-dialog__closed-task-chip"
                >
                  <span>{{ details.approved || 0 }}</span>
                </v-chip>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
        </v-card-text>
      </div>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'TaskStatusReportDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    statusDetails: {
      type: Object,
      default: () => ({}),
    },
    userType: {
      type: String,
      default: '',
    },
  },
  computed: {
    details() {
      if (!this.statusDetails || !this.userType) return {};
      // API returns keys 'manager' and 'user'; preparer/approver map to 'user'
      const key = this.userType === 'manager' ? 'manager' : 'user';
      return this.statusDetails[key] || {};
    },
  },
};
</script>
